import React from 'react';
import styled, { css } from 'styled-components';

import BreadcrumbExampleShorthand from 'comps/breadcrumbs';
import AppHeader from 'comps/header';
import TabMenu from 'comps/tab-menu';
import { COLORS } from '@cuemath/comps';
import { hideBreadcrumbs, hideAppHeader } from '../utils';
import MaintenanceBanner from 'comps/banner/maintenance';

const Root = styled.div`
  display: flex;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 72px;
  width: 100%;
  height: 100vh;
`;

const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const TopHeader = styled.div`
  ${({ hide }) => css`
    display: ${hide ? 'none' : 'flex'};
  `}
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  padding: 0 16px;
  border-bottom: 1px solid ${COLORS.GHOST};
  background-color: ${COLORS.WHITE};
`;

const BreadcrumbsWrapper = styled.div`
  min-width: 335px;
  height: 100%;
  display: flex;
  align-items: center;
`;

export default function Layout(props) {
  const showAppHeader = !hideAppHeader();
  const showBreadcrumbs = !hideBreadcrumbs();

  return (
    <Root>
      {showAppHeader && <AppHeader />}
      <Content>
        <TopHeader hide={!showBreadcrumbs}>
          <BreadcrumbsWrapper>
            <BreadcrumbExampleShorthand />
          </BreadcrumbsWrapper>
          <TabMenu />
        </TopHeader>
        <MaintenanceBanner />
        <ScrollableContent>{props.children}</ScrollableContent>
      </Content>
    </Root>
  );
}
